import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { loadCss } from "helpers/function";
import { verifyPermission } from "helpers/permission";
import { ERROR_401 } from "config/errorPage";
import LoadingTable from "views/components/LoadingTable";
import HeaderTablePage from "views/components/HeaderTablePage";
import InfirmationTable from "views/components/InfirmationTable";
import Pagination from "views/components/Pagination";
import { useReportingMetadata } from "hooks/configs/titre-rapport/useReportingMetadata";
import { usePagination } from "hooks/configs/titre-rapport/usePagination";
import { useSearch } from "hooks/configs/titre-rapport/useSearch";
import SearchInput from "components/configs/titre-rapport/SearchInput";
import ReportingTable from "components/configs/titre-rapport/ReportingTable";
import DataTableInfo from "components/configs/titre-rapport/DataTableInfo";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const ConfigTitreRapport = (props) => {
  const { t } = useTranslation();
  React.useEffect(() => {
    document.title = "Satis Paramètre Titre Rapport - Configuration formulaire";
  }, []);

  const hasPermission = React.useMemo(() => {
    return verifyPermission(
      props.userPermissions,
      "update-reporting-titles-configs"
    );
  }, [props.userPermissions]);

  React.useEffect(() => {
    if (!hasPermission) {
      window.location.href = ERROR_401;
    }
  }, [hasPermission]);

  const { loading, component, deleteComponent } = useReportingMetadata();

  const { searchElement } = useSearch(component);

  const {
    showList,
    numberPerPage,
    activeNumberPage,
    numberPage,
    pages,
    onChangeNumberPerPage,
    onClickPage,
    onClickNextPage,
    onClickPreviousPage,
    searchWithPagination,
  } = usePagination(component, searchElement);

  const handleSearch = React.useCallback(
    (searchValue) => {
      searchWithPagination(searchValue);
    },
    [searchWithPagination]
  );

  if (!hasPermission) return null;

  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <span className="kt-subheader__separator kt-hidden" />
              <div className="kt-subheader__breadcrumbs">
                <a href="#icone" className="kt-subheader__breadcrumbs-home">
                  <i className="flaticon2-shelter" />
                </a>
                <span className="kt-subheader__breadcrumbs-separator" />
                <a
                  href="#button"
                  onClick={(e) => e.preventDefault()}
                  className="kt-subheader__breadcrumbs-link"
                >
                  Configurations Titre Rapport
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <InfirmationTable information={t("Configuration des titres")} />

        <div className="kt-portlet">
          <HeaderTablePage title={t("Configuration Titre Rapport")} />

          {loading ? (
            <LoadingTable />
          ) : (
            <div className="kt-portlet__body">
              <div
                id="kt_table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="row">
                  <div className="col-sm-6 text-left">
                    <SearchInput onSearch={handleSearch} />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <ReportingTable
                      component={component}
                      showList={showList}
                      onDelete={deleteComponent}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-5">
                    <DataTableInfo
                      numberPerPage={numberPerPage}
                      totalItems={component.length}
                    />
                  </div>
                  {showList.length > 0 && (
                    <div className="col-sm-12 col-md-7 dataTables_pager">
                      <Pagination
                        numberPerPage={numberPerPage}
                        onChangeNumberPerPage={onChangeNumberPerPage}
                        activeNumberPage={activeNumberPage}
                        onClickPreviousPage={onClickPreviousPage}
                        pages={pages}
                        onClickPage={onClickPage}
                        numberPage={numberPage}
                        onClickNextPage={onClickNextPage}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(ConfigTitreRapport);
